import { RouteRecordRaw } from 'vue-router'
// 路由

/**
 * meta:{
 *     title:'登录', 页面标题/菜单标题
 *     icon:'',     菜单图标
 *     hidden:true, 是否在菜单中以隐藏
 *     hiddenTab:true 是否在tab栏中隐藏
 *     permission: 菜单权限编码（对应localStorage中的permissionCodes）
 * }
 */

export const commonRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/home',
    meta: {
      title: '首页',
      icon: 'dashboard',
    },
    children: [{
      path: '/home',
      name: 'home',
      component: () => import('@/views/Home/home.vue'),
      meta: {
        title: '首页',
        icon: '',
      },
    }]
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue'),
    meta: {
      title: '登录',
      icon: '',
      hidden: true,
      hiddenTab: true
    }
  },
  // 个人中心
  {
    path: '/user',
    component: () => import('@/layout/index.vue'),
    redirect: '/user/userInfo',
    meta: {
      title: '个人中心',
      icon: 'user',
      hidden: true,
      hiddenTab: true,
    },
    children: [{
      path: 'userInfo',
      name: 'userInfo',
      component: () => import('@/views/userCenter/userInfo.vue'),
      meta: {
        title: '个人中心',
        icon: '',
      },
    }]
  },
  {
    path: '/shop',
    component: ()=>import('@/layout/index.vue'),
    redirect:'/shop/list',
    meta:{
      title:'商品管理',
      icon:'cashier',
    },
    children: [{
      path:'productList',
      name:'productList',
      component: ()=>import('@/views/shopManage/productList.vue'),
      meta:{
        title:'商品管理',
        icon:''
      },
    },{
      path:'addProduct',
      name:'addProduct',
      component: ()=>import('@/views/shopManage/editProduct.vue'),
      meta:{
        title:'添加商品',
        icon:'',
      },
    },{
      path:'edit',
      name:'productEdit',
      component: ()=>import('@/views/shopManage/editProduct.vue'),
      meta:{
        title:'商品管理',
        icon:'',
        hiddenTab: true,
        hidden: true
      },
    },{
      path:'skuManage',
      name:'skuManage',
      component: ()=>import('@/views/shopManage/skuManage.vue'),
      meta:{
        title:'SKU管理',
        icon:'',
        hiddenTab: true,
        hidden: true
      },
    },{
      path:'stock',
      name:'shopStock',
      component: ()=>import('@/views/shopManage/stock/overview.vue'),
      meta:{
        title:'库存总览',
        icon:''
      },
    },{
      path:'stockManage',
      name:'shopStockManage',
      component: ()=>import('@/views/shopManage/stock/stock.vue'),
      meta:{
        title:'库存管理',
        icon:''
      },
    },{
      path:'stockLog',
      name:'shopStockLog',
      component: ()=>import('@/views/shopManage/stock/stockLog.vue'),
      meta:{
        title:'库存流水',
        icon:''
      },
    },{
      path:'stockWarn',
      name:'shopStockWarn',
      component: ()=>import('@/views/shopManage/stock/stockWarn.vue'),
      meta:{
        title:'库存预警',
        icon:''
      },
    }
  ]
  },
  {
    path: '/order',
    component: ()=>import('@/layout/index.vue'),
    redirect:'/order/list',
    meta:{
      title:'订单管理',
      icon:'report',
    },
    children: [{
      path:'list',
      name:'order_list',
      component: ()=>import('@/views/orderManage/list.vue'),
      meta:{
        title:'订单列表',
        icon:''
      },
    },{
      path:'details',
      name:'order_details',
      component: ()=>import('@/views/orderManage/details.vue'),
      meta:{
        title:'订单详情',
        icon:'',
        hidden:true,
        hiddenTab:true
      },
    },{
      path:'refundList',
      name:'refundList',
      component: ()=>import('@/views/refundManage/refundList.vue'),
      meta:{
        title:'订单退款',
        icon:''
      },
    },{
     path:'refundDetails',
     name:'refundDetails',
     component: ()=>import('@/views/refundManage/refundDetails.vue'),
     meta:{
       title:'订单详情',
       icon:'',
       hidden:true,
       hiddenTab:true
     },
   }]
  },
  // 店铺管理
  {
    path: '/store',
    component: ()=>import('@/layout/index.vue'),
    redirect:'/store/list',
    meta:{
      title:'店铺管理',
      icon:'venue',
    },
    children: [{
      path:'storeInfo',
      name:'storeInfo',
      component: ()=>import('@/views/storeManage/info.vue'),
      meta:{
        title:'店铺信息',
        icon:''
      },
    }   ,{
      path:'selfpack',
      name:'selfpackList',
      component: ()=>import('@/views/storeManage/selfpackList.vue'),
      meta:{
        title:'自提点管理',
        icon:''
      },
    },{
      path:'account',
      name:'storeAccount',
      component: ()=>import('@/views/storeManage/account/index.vue'),
      meta:{
        title:'我的账户',
        icon:''
      },
    },{
      path:'withdraw',
      name:'storeWithdraw',
      component: ()=>import('@/views/storeManage/withdraw/index.vue'),
      meta:{
        title:'店铺提现',
        icon:''
      },
    },{
      path:'fundOverview',
      name:'storeFundOverview',
      component: ()=>import('@/views/storeManage/fund/overview.vue'),
      meta:{
        title:'资金概览',
        icon:''
      },
    },{
      path:'accountLog',
      name:'storeAccountLog',
      component: ()=>import('@/views/storeManage/account/accountLog.vue'),
      meta:{
        title:'资金明细',
        icon:''
      },
    },{
      path:'details',
      name:'storeDetails',
      component: ()=>import('@/views/storeManage/details.vue'),
      meta:{
        title:'店铺详情',
        icon:'',
        hidden:true,
        hiddenTab:true
      },
    }]
  },
    //  收益管理
    {
      path: '/income',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/income/incomeManage',
      meta:{
        title:'收益管理',
        icon:'income',
        role:["机构",'union',]
      },
      children: [{
        path:'incomeManage',
        name:'incomeManage',
        component: ()=>import('@/views/incomeManage/index.vue'),
        meta:{
          title:'收益详情',
          icon:''
        },
      },{
        path:'account',
        name:'account',
        component: ()=>import('@/views/incomeManage/account.vue'),
        meta:{
          title:'提现账户',
          icon:''
        },
      }]
    },

  {
    path: '/:path(.*)*',
    component: () => import('@/views/err/404.vue'),
    meta: {
      title: '404',
      icon: '',
      hidden: true,
      hiddenTab: true
    }
  }
]